import React from "react";
import { WixCategoriesUIProvider } from "./WixCategoriesUIContext";
import WixCategoriesCard from "./WixCategories";
import { Route } from "react-router-dom";
import { CategoryViewDialog } from "./wix-category-table/category-dialogue/CategoryViewDialogue";


export function WixCategoriesPage({ history }) {

  const wixCategoriesUIEvents = {
  
    openEditWixCategoryPage: (id, total) => {
      history.push(`/app/wix-categories/${id}/${total}/edit`);
    },

    openViewWixCategoryPage: (id) => {
      history.push(`/app/wix-categories/${id}/view`);
    },
   
  };
  
  return (
    <WixCategoriesUIProvider wixCategoriesUIEvents={wixCategoriesUIEvents}>
      <WixCategoriesCard />
    </WixCategoriesUIProvider>
  );
}
